const state = {
    userName: '',//用户名
    roles:'', //角色code
    deptCode:'',
    businessLine:'', //业务线：0国内 1国际
    staffCode:'', //职员code
    leaderFirst:'', //用来判断角色类型的： 1主管 2普通角色 3特殊角色
    staffStatus:"", //职员在职状态
    crumbsArr:[{name:'首页',url:'/home'}], //面包屑路径
    menu:[], //路由
    jumpMenu:{}, //页面内的路由跳转
    logUrl:'', //存储跳转地址
    buttons:[], // 页面按钮集合
    menuWidth:'' ,//aside的宽度
    tokens:'', // token值
 
    routeList:[], //路由表
    visitedViews: [],//Tabs视图
    cachedViews: [], //需要缓存视图

    JumpParams:{}, //跳转带参
};
export default state;


// WEBPACK FOOTER //
// ./src/store/state.js